module.exports = {

  // Extend the changeLocale function of i18n.js to allow overriding of
  // strings whenever the language is changed.
  changeLocale: function(locale, callback){
    i18n.changeLocale(locale, function(){
      // now this is the new part! override with branding texts!
      var keys = [];
      for(var k in Mulligan.Brand.Text){
        if (Mulligan.Brand.Text.hasOwnProperty(k)) {
          keys.push(k);
        }
      }
      for (var i=0;i < keys.length;i++){
        var key = keys[i];
        var value = Mulligan.Brand.Text[key];
        var parts = key.split(".").reverse();
        var current = value || false;
        for (var j=0;j < parts.length;j++){
          var part = parts[j];
          var tmp = {};
          tmp[part] = current;
          current = tmp;
        }
        i18n.extendLocale(current);
      }
      if (callback){
        callback();
      }
    });
  },

  locales: {
    "en": require('../../locales/en'),
    "ar": require('../../locales/ar'),
    "bg": require('../../locales/bg'),
    "ca": require('../../locales/ca'),
    "cs": require('../../locales/cs'),
    "cy": require('../../locales/cy'),
    "da": require('../../locales/da'),
    "de": require('../../locales/de'),
    "el": require('../../locales/el'),
    "en_GB": require('../../locales/en_GB'),
    "es": require('../../locales/es'),
    "es_MX": require('../../locales/es_MX'),
    "fi": require('../../locales/fi'),
    "fil": require('../../locales/fil'),
    "fr_CA": require('../../locales/fr_CA'),
    "fr": require('../../locales/fr'),
    "ga": require('../../locales/ga'),
    "he": require('../../locales/he'),
    "hi": require('../../locales/hi'),
    "is": require('../../locales/is'),
    "it": require('../../locales/it'),
    "ja": require('../../locales/ja'),
    "ko": require('../../locales/ko'),
    "nl": require('../../locales/nl'),
    "no": require('../../locales/no'),
    "pl": require('../../locales/pl'),
    "pt_BR": require('../../locales/pt_BR'),
    "pt": require('../../locales/pt'),
    "ro": require('../../locales/ro'),
    "ru": require('../../locales/ru'),
    "sv": require('../../locales/sv'),
    "th": require('../../locales/th'),
    "tr": require('../../locales/tr'),
    "vi": require('../../locales/vi'),
    "zh_CN": require('../../locales/zh_CN'),
    "zh_TW": require('../../locales/zh_TW')
  }

};



/** WEBPACK FOOTER **
 ** ./src/js/utils/locales.js
 **/